export const meetingsData = [
  {
    _id: 'm1',
    id: 'm1',
    requesterName: 'Budi Santoso',
    room: 'Ruang Rapat A',
    date: '2026-02-02',
    startTime: '09:00',
    endTime: '10:30',
    attendees: 6,
    purpose: 'Meeting koordinasi project X',
    status: 'Pending',
    notes: ''
  },
  {
    _id: 'm2',
    id: 'm2',
    requesterName: 'Siti Nur',
    room: 'Ruang Rapat B',
    date: '2026-02-03',
    startTime: '13:00',
    endTime: '15:00',
    attendees: 10,
    purpose: 'Presentasi vendor',
    status: 'Approved',
    notes: 'Butuh projector'
  }
];

export default meetingsData;
